import React from 'react';
import factory from 'components/Icons/factory';

// Icons are built as 128x128 originals
export const Arrow = factory(
  // Default arrow points right
  'Arrow',
  <path d="M102.4 68.5L58 124c-2 2.7-5.2 2.7-7.2 0l-7.2-9a7.8 7.8 0 0 1 0-8.7l34.3-42-34.6-42.7a7.5 7.5 0 0 1 0-8.8l7.2-9c1.8-2.4 5-2.4 7 0l44.8 55.8a7 7 0 0 1 0 9z" />
);

export default Arrow;
